module.exports = __webpack_public_path__ + "img/security_electrical_fault.2fb495bb.svg";